import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { openDataModel } from "./openDataModel";
import { OpenDataTable } from "./OpenDataTable";
import { OpenSearchBox } from "./OpenSearchBox";
import { OpenDrawer } from "./OpenDrawer";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const OpenDataBox = () => {

    const { selectedRowKeys, selectedData,
        setOpenDrawerVisible
    } = openDataModel();

    const onApproval = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            if (selectedData[0]?.status === 1) {
                setOpenDrawerVisible(true);
            } else {
                message.error("该条记录不可审核!");
            }
        } else {
            message.error("请选择待审核记录!");
        }
    }

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_CONTRACT_OPEN_AUDIT}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={onApproval}
                    >
                        审核
                    </Button>
                </YhAuth>
            </div >
        </>
    );

    return (
        <>
            <OpenSearchBox />
            <YhBox title={action} >
                <OpenDataTable />
            </YhBox>
            <OpenDrawer />
        </>
    )
}
